import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ActivityType from '../../entities/activityType';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteActivityType(): boolean {
return true;
}
export function collectActivityTypeDeleteImpact(activityType: ActivityType, context: DeleteImpactContext): void {
const key = 'activityType:' + activityType.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const taskActivityTypeIdsImpact = workingRows<Task>('task', findAll<Task>('tasks')).filter(taskRef => taskRef.activityTypeIds?.includes(activityType.id));
taskActivityTypeIdsImpact.forEach(taskRef => addDeleteImpact(context, 'task:' + taskRef.id, 'tasks'));
const templateTaskActivityTypeIdsImpact = workingRows<TemplateTask>('templateTask', findAll<TemplateTask>('templateTasks')).filter(templateTaskRef => templateTaskRef.activityTypeIds?.includes(activityType.id));
templateTaskActivityTypeIdsImpact.forEach(templateTaskRef => addDeleteImpact(context, 'templateTask:' + templateTaskRef.id, 'templateTasks'));}
export function deleteImpactActivityType(activityType: ActivityType): DeleteImpact {
const context = deleteImpactContext();
collectActivityTypeDeleteImpact(activityType, context);
return deleteImpactCounts(context);
}
export function deleteActivityType(activityType: ActivityType, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteActivityType()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectActivityTypeDeleteImpact(activityType, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || activityType.id};
}
const key = 'activityType:' + activityType.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('activityTypeId', activityType.id)]).filter(taskTemp => taskTemp.activityTypeIds?.includes(activityType.id)).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.activityTypeIds = _task.activityTypeIds?.filter(id => id !== activityType.id) || [];

_work.set('task:' + _task.id, _task);
dispatch(Actions.TaskActions.saveTaskQueue(_task), 'task:' + _task.id);
});
workingRows<TemplateTask>('templateTask', [...store.getState().templateTasks.getMappingFor('activityTypeIds', activityType.id)]).filter(templateTaskTemp => templateTaskTemp.activityTypeIds?.includes(activityType.id)).forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
if (_templateTask.status === 'D') return;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.activityTypeIds = _templateTask.activityTypeIds?.filter(id => id !== activityType.id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask), 'templateTask:' + _templateTask.id);
});
const deleted = activityType.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.ActivityTypeActions.removeActivityTypeQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceActivityType(activityType: ActivityType, replaceWith: ActivityType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityType.id;}
const _work = workingSet();
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('activityTypeId', activityType.id)]).filter(taskTemp => taskTemp.activityTypeIds?.includes(activityType.id)).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.activityTypeIds = _task.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
workingRows<TemplateTask>('templateTask', [...store.getState().templateTasks.getMappingFor('activityTypeIds', activityType.id)]).filter(templateTaskTemp => templateTaskTemp.activityTypeIds?.includes(activityType.id)).forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
if (_templateTask.status === 'D') return;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.activityTypeIds = _templateTask.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



return activityType;
}
